import { render, staticRenderFns } from "./projectCredits.vue?vue&type=template&id=801bfc10&scoped=true&"
import script from "./projectCredits.vue?vue&type=script&lang=js&"
export * from "./projectCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801bfc10",
  null
  
)

export default component.exports